import { render, staticRenderFns } from "./minus.vue?vue&type=template&id=7abbb93e&"
import script from "./minus.vue?vue&type=script&lang=js&"
export * from "./minus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports